import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppCfgMainQueryCriteriaClass extends BaseCriteriaModel {
  // Header table
  txn_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();

  // Ext table
  hdr_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class AppCfgCriteriaModelQuery {
  query = '';

  constructor(appCfgCriteriaModel: AppCfgMainQueryCriteriaClass) {

    if (!appCfgCriteriaModel) {
      return;
    }

    this.query += appCfgCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += appCfgCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += appCfgCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');

    this.query += appCfgCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += appCfgCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += appCfgCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += appCfgCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += appCfgCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');

    this.query += '&status=' + appCfgCriteriaModel.status;
    this.query += '&orderBy=' + appCfgCriteriaModel.orderBy;
    this.query += '&order=' + appCfgCriteriaModel.order;
    this.query += '&offset=' + appCfgCriteriaModel.offset + '&limit=' + appCfgCriteriaModel.limit;
  }
}
